import React from 'react';
import PropTypes from 'prop-types';
import TitleEmoji from '../TitleEmoji';
import Text from '../Text';
import StyledModalError from './style';

const ModalError = ({ onCloseModal, error }) => (
  <StyledModalError
    onButton="center"
    buttonTxt="Aceptar"
    onClose={() => {
      onCloseModal();
    }}
    onClickButton={() => onCloseModal()}
  >
    <TitleEmoji text="Se ha producido un error" emotion="triste" />
    <Text>{error}</Text>
  </StyledModalError>
);

ModalError.propTypes = {
  onCloseModal: PropTypes.func,
  error: PropTypes.string
};

export default ModalError;
